export const Verticals = {
  Education:             1,
  Personal:              2,
  Vehicle:               3,
  Mortgage:              4,
  TermLoan:              5,
  Consumer:              6,
  Business:              7,
  LoanAgainstSecurities: 8,
};
